const TypeForm = Object.freeze({
  INPUT: 'input',
  INPUT_NUMBER: 'input_number',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  RADIO: 'radio',
  DATEPICKER: 'datepicker',
  SELECT_AJAX: 'select_ajax',
  BOOLEAN_RADIO: 'boolean_radio',
  CHECKBOX_LIST: 'checkbox_list',
  SELECT_CONTACT_DOSSIER: 'select_contact_dossier',
  SELECT_TRANSFERT_DOSSIER: 'select_transfert_dossier',
  SELECT_FUNERAILLES_DOSSIER: 'select_funerailles_dossier',
  SELECT_CEREMONY_DOSSIER: 'select_ceremony_dossier',
  SELECT_VISIT_DOSSIER: 'select_visit_dossier',
  SELECT_INVOICE_DOSSIER: 'select_invoice_dossier',
  SELECT_DEMANDEUR_FORM: 'select_demandeur_form',
  SELECT_ITEM_CATEGORY_DOSSIER: 'select_item_category_dossier',
  SELECT_EVENT_DETAILS_DOSSIER: 'select_event_details_dossier',
  SELECT_ITEM_DETAILS_DOSSIER: 'select_item_details_dossier'
})

// Field types whose infos can be placed one by one in the document editor
export const ITEM_INFOS_FIELD_TYPES = Object.freeze([
  TypeForm.SELECT_CONTACT_DOSSIER,
  TypeForm.SELECT_DEMANDEUR_FORM,
  TypeForm.SELECT_VISIT_DOSSIER,
  TypeForm.SELECT_TRANSFERT_DOSSIER,
  TypeForm.SELECT_CEREMONY_DOSSIER,
  TypeForm.SELECT_FUNERAILLES_DOSSIER,
  TypeForm.SELECT_EVENT_DETAILS_DOSSIER,
  TypeForm.SELECT_INVOICE_DOSSIER
])

// Rich text fields written from the config of FormFieldEventInfosConfig: they
// keep their own element on the page and are not in ITEM_INFOS_FIELD_TYPES
// when they have no infos to place one by one
export const EVENT_INFOS_FIELD_TYPES = Object.freeze([
  TypeForm.SELECT_EVENT_DETAILS_DOSSIER,
  TypeForm.SELECT_ITEM_DETAILS_DOSSIER
])

export default TypeForm
